const Line = () => {
    return (
        <div className={`line-container`}>
            <div className={`line`}></div>
        </div>
    );
}

export default Line;